import React, { useState } from 'react';
import { DPSHeader } from './DPSHeader';
import { DPSNavigation } from './DPSNavigation';
import { dpsTheme } from '../../../styles/dpsTheme';
import { useDeviceSize } from '../../../hooks/useMediaQuery';

interface DPSLayoutProps {
  children: React.ReactNode;
  reportId: string;
  onDownloadPDF?: () => void;
}

export const DPSLayout: React.FC<DPSLayoutProps> = ({ children, reportId, onDownloadPDF }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { isMobile } = useDeviceSize();

  return (
    <div
      style={{
        fontFamily: dpsTheme.typography.fontFamily,
        background: dpsTheme.colors.background.primary,
        minHeight: '100vh',
        color: dpsTheme.colors.text.secondary,
        paddingBottom: '4rem',
      }}
    >
      <DPSHeader onDownloadPDF={onDownloadPDF} onMenuToggle={() => setSidebarOpen(!sidebarOpen)} />
      {isMobile && sidebarOpen && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0.6)',
            zIndex: 99,
            backdropFilter: 'blur(2px)',
          }}
          onClick={() => setSidebarOpen(false)}
        />
      )}
      <DPSNavigation reportId={reportId} isOpen={isMobile ? sidebarOpen : true} onClose={() => setSidebarOpen(false)} />
      <div style={{ paddingTop: isMobile ? '24px' : '40px' }}>
        {children}
      </div>
    </div>
  );
};
